import { checkAndReAuth } from "../actions/auth";
import { getCurrentBalance } from "./../actions/balance";
import enums from "./../enums";

//currency_info
let currency = localStorage.getItem("currency");

const balance = (
	state = {
		wallet: {},
		currency: currency,
		currencies: [],
		convertionRates: [],
		walletDetails: {},
		depositLoading: false,
		wagering: {},
	},
	action
) => {
	switch (action.type) {
		case enums.CONVERSION_RATES: {
			return { ...state, convertionRates: action.payload };
		}
		case enums.CURRENCIES: {
			return { ...state, currencies: action.payload };
		}
		case enums.DEPOSIT_LOADING: {
			return { ...state, depositLoading: action.payload };
		}
		case enums.BALANCE_UPDATED: {
			const { walletDetails, ...rest } = action.payload;
			return {
				...state,
				wallet: rest,
				currency: rest.real.currency,
				wagering: walletDetails.reduce((prev, current) => {
					prev[current.walletId] = current;
					return prev;
				}, {}),
			};
		}
		case enums.BALANCE: {
			//we need to call another action because it's a socket
			action.asyncDispatch(getCurrentBalance());
			checkAndReAuth(action.asyncDispatch);
			return { ...state };
		}
		default:
			return { ...state };
	}
};

export default balance;
